import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { InvoiceRecord } from '../entities/records';
import * as selectors from '../entities/Invoice/selectors';

function mapStateToProps(state, { invoiceId }) {
  return {
    invoice: selectors.invoiceById(state, invoiceId),
  };
}

export default compose(
  setPropTypes({
    invoiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    invoice: PropTypes.instanceOf(InvoiceRecord),
  }),
)(mapStateToProps);
